<!--
 * @Date: 2022-12-08 11:38:10
 * @LastEditTime: 2022-12-22 19:38:54
 * @Description: file content
-->
<template>
  <div
    class="annual-record"
    @touchstart="touchStart"
    @touchmove="touchMove"
    @touchend="touchEnd"
  >
    <pageOne
      :class="{
        'page-one': true,
        disappear: isDisappear,
      }"
      :platform="platform"
      :detail="detail"
      @animate-end="handleAnimateEnd"
      @jumpToRules="jumpToRules"
      @openUrlLink="openUrlLink"
    />
    <div v-show="isOpeningEnded">
      <pageTwo v-show="pageStatus[1]" :trigger="pageStatus[1]" />
      <pageThere v-show="pageStatus[2]" :trigger="pageStatus[2]" />
      <pageFour v-show="pageStatus[3]" :trigger="pageStatus[3]" />
    </div>

    <!-- </full-page> -->
  </div>
</template>

<script>
import * as cyDetect from '@cy/detect';
import cyShare from '@cy/share';
import { doPoint } from '@/utils/index';
import { getThanksGivingHome, getUrlLink } from '@/services/index';
import pageOne from './components/AnnualRecord/page1.vue';
import pageTwo from './components/AnnualRecord/page2.vue';
import pageThere from './components/AnnualRecord/page3.vue';
import pageFour from './components/AnnualRecord/page4.vue';

const wx = require('weixin-js-sdk');

export default {
  components: {
    // VueFullPage,
    pageOne,
    pageTwo,
    pageThere,
    pageFour,
  },
  data() {
    return {
      isDisappear: false,
      detail: {},
      pageStatus: [false, false, false, false],
      isOpeningEnded: false,
      startPosY: 0,
      movePosY: 0,
      currentIndex: -1,
      activityAlias: this.$route.query.activity_alias,
      ruleUrl: '',
      platform: '',
    };
  },
  watch: {
    currentIndex(val) {
      console.log(val);
      if (val > 1) {
        this.doPagePoint('ActivityClick', {
          activity_name: '12月年终感恩活动',
          click_position: '翻页',
          page_title: `年度回顾第${val}页`,
        });
      }

      this.doPagePoint('ActivityPageView', {
        activity_name: '12月年终感恩活动',
        page_title: `年度回顾第${val + 1}页`,
      });
    },
  },
  created() {
    this.currentIndex = 0;
    this.getThanksGivingHomeList();
    this.getPlatForm();
    this.onShare();
  },
  methods: {
    /**
     * @description: 获取页面详情
     */
    getThanksGivingHomeList() {
      try {
        getThanksGivingHome({ activity_alias: this.activityAlias })
          .then(res => {
            const { error_code, error_msg, data } = res;
            if (error_code === 0) {
              const index = data.findIndex(i => i.unique_key === 'draw_info');
              this.ruleUrl = data[index].rule_url;
            } else {
              console.log(error_msg);
            }
          })
          .catch(e => {
            console.log(e);
          });
      } catch (e) {
        console.log(e);
      }
    },
    async jumpToRules() {
      await this.doPagePoint('ActivityClick', {
        activity_name: '12月年终感恩活动',
        click_position: '活动规则',
        page_title: `年度回顾第1页`,
      });
      window.location.href = this.ruleUrl;
    },
    handleAnimateEnd() {
      this.isOpeningEnded = true;
      this.$set(this.pageStatus, 1, true);
      this.currentIndex = 1;
      this.isDisappear = true;
      this.doPagePoint('ActivityClick', {
        activity_name: '12月年终感恩活动',
        click_position: '参与有礼',
        page_title: `年度回顾第1页`,
      });
    },
    touchStart(e) {
      this.startPosY = e.touches[0].pageY;
    },
    touchMove(e) {
      this.movePosY = e.touches[0].pageY;
    },
    async touchEnd() {
      if (!this.movePosY) return;
      const distance = this.startPosY - this.movePosY;
      if (Math.abs(distance) > 60) {
        if (distance > 0) {
          if (this.currentIndex < this.pageStatus.length - 1) {
            this.$set(this.pageStatus, this.currentIndex, false);
            this.currentIndex += 1;
            this.$set(this.pageStatus, this.currentIndex, true);
          } else {
            await this.doPagePoint('ActivityClick', {
              activity_name: '12月年终感恩活动',
              click_position: '翻页',
              page_title: `年度回顾第4页`,
            });
            this.$router.push({
              name: 'AnnualLottery',
              query: {
                activity_alias: this.activityAlias,
              },
            });
          }
        } else if (distance < 0 && this.currentIndex > 1) {
          this.$set(this.pageStatus, this.currentIndex, false);
          this.currentIndex -= 1;
          this.$set(this.pageStatus, this.currentIndex, true);
        }
      }
      this.movePosY = 0;
    },
    /**
     * 打点函数
     *
     * @param type type
     * @param data 打点数据
     */
    doPagePoint(type, data) {
      let app;
      if (this.platform === 'app') {
        app = '0';
      } else if (this.platform === 'clinic') {
        app = '1';
        // eslint-disable-next-line no-underscore-dangle
      } else if (this.platform === 'wxMini') {
        app = 'weixin_mini';
      }
      return doPoint(type, {
        app,
        ...data,
      });
    },
    /**
     * 分享设置
     *
     */
    onShare() {
      const params = {
        title:
          '感恩有你 健康同行，请查收你的新年开运签，参与活动即可领取新年福袋，100%中奖 ，200元话费充值、小熊加湿器、50元现金红包等好礼等你拿',
        page_title:
          '感恩有你 健康同行，请查收你的新年开运签，参与活动即可领取新年福袋，100%中奖 ，200元话费充值、小熊加湿器、50元现金红包等好礼等你拿', // 标题
        desc:
          '请查收你的新年开运签，参与活动即可领取新年福袋，100%中奖 ，200元话费充值、小熊加湿器、50元现金红包等好礼等你拿', // 描述
        mini_image:
          'https://resource.chunyu.mobi/@/media/images/2022/12/16/2073/7c8fcb9a69ce_w420_h340_.jpg',
        img:
          'https://resource.chunyu.mobi/@/media/images/2022/12/16/2073/7c8fcb9a69ce_w420_h340_.jpg', // 分享的图片展示
        link: window.location.href,
        userName: 'gh_681d3fd5683f', // 安卓
        mini_id: 'gh_681d3fd5683f', // IOS
        need_invitate_id: false,
        wx_scene_timeline_desc:
          '感恩有你 健康同行,请查收你的新年开运签，参与活动即可领取新年福袋，100%中奖 ，200元话费充值、小熊加湿器、50元现金红包等好礼等你拿',
        path: `/pages/h5_webview/index?url=${encodeURIComponent(
          window.location.href
        )}`,
      };
      cyShare.app(params);
    },
    /**
     * @description: 获取url-link并打开
     */
    openUrlLink() {
      try {
        getUrlLink({
          page: encodeURIComponent('/pages/h5_webview/index'),
          is_json: '1',
          scene: `${encodeURIComponent(
            `url=${encodeURIComponent(`${window.location.href}`)}`
          )}`,
        })
          .then(res => {
            const { error_code, error_msg, url_link } = res;
            if (error_code === 0) {
              const wxUrl = url_link || '';
              if (wxUrl) {
                window.location.href = wxUrl;
              }
            } else {
              console.log(error_msg);
            }
          })
          .catch(e => {
            console.log(e);
          });
      } catch (e) {
        console.log(e);
      }
    },
    getPlatForm() {
      return new Promise(res => {
        if (cyDetect.isFromWechat()) {
          wx.miniProgram.getEnv(wxres => {
            if (wxres.miniprogram) {
              this.isWxMini = true;
              this.platform = 'wxMini';
              this.setWxMiniShare();
              res('wxMini');
            } else {
              this.isWxMini = false;
              this.platform = 'h5';
              res('h5');
            }
          });
        } else if (cyDetect.isFromCY()) {
          this.platform = 'app';
          res('app');
        } else if (cyDetect.isFromCYClinic()) {
          this.platform = 'clinic';
          res('clinic');
        } else {
          this.platform = 'h5';
          res('h5');
        }
      });
    },
    /**
     * 设置微信小程序分享
     */
    setWxMiniShare() {
      wx.miniProgram.getEnv(wxres => {
        if (wxres.miniprogram) {
          console.log('设置分享');
          wx.miniProgram.postMessage({
            data: {
              img: this.shareImg, // 分享的图片展示
              title:
                '感恩有你 健康同行，请查收你的新年开运签，参与活动即可领取新年福袋，100%中奖 ，200元话费充值、小熊加湿器、50元现金红包等好礼等你拿', // 标题
              link: encodeURIComponent(`${window.location.href}`), // 分享后点击卡片的跳转链接
              origin: 'common-activity/lottery', // 来源
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-one {
  &.disappear {
    display: none;
  }
}
.full-page {
  opacity: 0;

  &.showed {
    opacity: 1;
    animation-name: fadeIn;
    animation-duration: 1s;
    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }
}
</style>
